import { useQuery } from 'react-query';
import { USERS_API } from 'apis/user';

export const USER_CACHE_KEY = 'user';

export const useUser = () => useQuery(USER_CACHE_KEY, USERS_API.me);
